/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateFormTemplateRequest,
  ErrorEnvelope,
  FormDocument,
  FormTemplate,
  GetFieldPlacementsResponse,
  GetFormByTokenResponse,
  ListFormDocumentsResponse,
  ListFormTemplatesResponse,
  Problem,
  SendFormDocumentRequest,
  SubmitFormDocumentRequest,
  UpdateFieldPlacementsRequest,
  UpdateFormTemplateRequest,
} from '../models/index';
import {
    CreateFormTemplateRequestFromJSON,
    CreateFormTemplateRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    FormDocumentFromJSON,
    FormDocumentToJSON,
    FormTemplateFromJSON,
    FormTemplateToJSON,
    GetFieldPlacementsResponseFromJSON,
    GetFieldPlacementsResponseToJSON,
    GetFormByTokenResponseFromJSON,
    GetFormByTokenResponseToJSON,
    ListFormDocumentsResponseFromJSON,
    ListFormDocumentsResponseToJSON,
    ListFormTemplatesResponseFromJSON,
    ListFormTemplatesResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    SendFormDocumentRequestFromJSON,
    SendFormDocumentRequestToJSON,
    SubmitFormDocumentRequestFromJSON,
    SubmitFormDocumentRequestToJSON,
    UpdateFieldPlacementsRequestFromJSON,
    UpdateFieldPlacementsRequestToJSON,
    UpdateFormTemplateRequestFromJSON,
    UpdateFormTemplateRequestToJSON,
} from '../models/index';

export interface CancelFormDocumentRequest {
    claimId: number;
    formDocId: number;
}

export interface CreateFormTemplateOperationRequest {
    createFormTemplateRequest: CreateFormTemplateRequest;
}

export interface DeleteFormDocumentRequest {
    claimId: number;
    formDocId: number;
}

export interface DeleteFormTemplateRequest {
    id: number;
}

export interface GetCompletedFormPdfRequest {
    claimId: number;
    formDocId: number;
}

export interface GetFieldPlacementsRequest {
    id: number;
}

export interface GetFormByTokenRequest {
    accessToken: string;
}

export interface GetFormDocumentsByClaimRequest {
    claimId: number;
}

export interface GetFormTemplateByIdRequest {
    id: number;
}

export interface GetFormTemplatePdfRequest {
    id: number;
}

export interface GetPublicFormPdfRequest {
    accessToken: string;
}

export interface ListFormTemplatesRequest {
    includeInactive?: boolean;
}

export interface SendFormToHomeownerRequest {
    claimId: number;
    sendFormDocumentRequest: SendFormDocumentRequest;
}

export interface SubmitFormRequest {
    accessToken: string;
    submitFormDocumentRequest: SubmitFormDocumentRequest;
}

export interface UpdateFieldPlacementsOperationRequest {
    id: number;
    updateFieldPlacementsRequest: UpdateFieldPlacementsRequest;
}

export interface UpdateFormTemplateOperationRequest {
    id: number;
    updateFormTemplateRequest: UpdateFormTemplateRequest;
}

/**
 * FormTemplatesApi - interface
 * 
 * @export
 * @interface FormTemplatesApiInterface
 */
export interface FormTemplatesApiInterface {
    /**
     * Mark a sent form as cancelled
     * @summary Cancel a form document
     * @param {number} claimId Claim ID
     * @param {number} formDocId Form Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    cancelFormDocumentRaw(requestParameters: CancelFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>>;

    /**
     * Mark a sent form as cancelled
     * Cancel a form document
     */
    cancelFormDocument(requestParameters: CancelFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument>;

    /**
     * Upload a PDF form template
     * @summary Create a new form template
     * @param {CreateFormTemplateRequest} createFormTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    createFormTemplateRaw(requestParameters: CreateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>>;

    /**
     * Upload a PDF form template
     * Create a new form template
     */
    createFormTemplate(requestParameters: CreateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate>;

    /**
     * Soft deletes a completed or cancelled form document while retaining its database record and stored completed PDF blob for audit purposes
     * @summary Delete a form document
     * @param {number} claimId Claim ID
     * @param {number} formDocId Form Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    deleteFormDocumentRaw(requestParameters: DeleteFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Soft deletes a completed or cancelled form document while retaining its database record and stored completed PDF blob for audit purposes
     * Delete a form document
     */
    deleteFormDocument(requestParameters: DeleteFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Soft deletes the template while retaining its database record and stored PDF blob for audit purposes
     * @summary Delete a form template
     * @param {number} id Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    deleteFormTemplateRaw(requestParameters: DeleteFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Soft deletes the template while retaining its database record and stored PDF blob for audit purposes
     * Delete a form template
     */
    deleteFormTemplate(requestParameters: DeleteFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve the completed PDF file for a submitted form document
     * @summary Get completed form PDF
     * @param {number} claimId Claim ID
     * @param {number} formDocId Form Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getCompletedFormPdfRaw(requestParameters: GetCompletedFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve the completed PDF file for a submitted form document
     * Get completed form PDF
     */
    getCompletedFormPdf(requestParameters: GetCompletedFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retrieve field placement configuration for a form template
     * @summary Get field placements for a template
     * @param {number} id Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getFieldPlacementsRaw(requestParameters: GetFieldPlacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFieldPlacementsResponse>>;

    /**
     * Retrieve field placement configuration for a form template
     * Get field placements for a template
     */
    getFieldPlacements(requestParameters: GetFieldPlacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFieldPlacementsResponse>;

    /**
     * Retrieve form details for homeowner submission
     * @summary Get form by access token (public, no auth)
     * @param {string} accessToken UUID access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getFormByTokenRaw(requestParameters: GetFormByTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFormByTokenResponse>>;

    /**
     * Retrieve form details for homeowner submission
     * Get form by access token (public, no auth)
     */
    getFormByToken(requestParameters: GetFormByTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFormByTokenResponse>;

    /**
     * List all form documents sent for a specific claim
     * @summary Get form documents for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getFormDocumentsByClaimRaw(requestParameters: GetFormDocumentsByClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFormDocumentsResponse>>;

    /**
     * List all form documents sent for a specific claim
     * Get form documents for a claim
     */
    getFormDocumentsByClaim(requestParameters: GetFormDocumentsByClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFormDocumentsResponse>;

    /**
     * Retrieve a single form template
     * @summary Get a form template by ID
     * @param {number} id Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getFormTemplateByIdRaw(requestParameters: GetFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>>;

    /**
     * Retrieve a single form template
     * Get a form template by ID
     */
    getFormTemplateById(requestParameters: GetFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate>;

    /**
     * Retrieve the PDF file for a form template
     * @summary Get form template PDF
     * @param {number} id Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getFormTemplatePdfRaw(requestParameters: GetFormTemplatePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve the PDF file for a form template
     * Get form template PDF
     */
    getFormTemplatePdf(requestParameters: GetFormTemplatePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retrieve the original PDF template for a form document via access token
     * @summary Get form template PDF (public, no auth)
     * @param {string} accessToken UUID access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    getPublicFormPdfRaw(requestParameters: GetPublicFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve the original PDF template for a form document via access token
     * Get form template PDF (public, no auth)
     */
    getPublicFormPdf(requestParameters: GetPublicFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Get all form templates for the authenticated user\'s company
     * @summary List all form templates
     * @param {boolean} [includeInactive] Include inactive templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    listFormTemplatesRaw(requestParameters: ListFormTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFormTemplatesResponse>>;

    /**
     * Get all form templates for the authenticated user\'s company
     * List all form templates
     */
    listFormTemplates(requestParameters: ListFormTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFormTemplatesResponse>;

    /**
     * Create a form document instance and send it to the homeowner
     * @summary Send a form to a homeowner
     * @param {number} claimId Claim ID
     * @param {SendFormDocumentRequest} sendFormDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    sendFormToHomeownerRaw(requestParameters: SendFormToHomeownerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>>;

    /**
     * Create a form document instance and send it to the homeowner
     * Send a form to a homeowner
     */
    sendFormToHomeowner(requestParameters: SendFormToHomeownerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument>;

    /**
     * Homeowner submits the filled form with annotations and signature
     * @summary Submit a form (public, no auth)
     * @param {string} accessToken UUID access token
     * @param {SubmitFormDocumentRequest} submitFormDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    submitFormRaw(requestParameters: SubmitFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>>;

    /**
     * Homeowner submits the filled form with annotations and signature
     * Submit a form (public, no auth)
     */
    submitForm(requestParameters: SubmitFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument>;

    /**
     * Update field placement configuration for a form template
     * @summary Update field placements for a template
     * @param {number} id Template ID
     * @param {UpdateFieldPlacementsRequest} updateFieldPlacementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    updateFieldPlacementsRaw(requestParameters: UpdateFieldPlacementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFieldPlacementsResponse>>;

    /**
     * Update field placement configuration for a form template
     * Update field placements for a template
     */
    updateFieldPlacements(requestParameters: UpdateFieldPlacementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFieldPlacementsResponse>;

    /**
     * Update template metadata (not the PDF itself)
     * @summary Update a form template
     * @param {number} id Template ID
     * @param {UpdateFormTemplateRequest} updateFormTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormTemplatesApiInterface
     */
    updateFormTemplateRaw(requestParameters: UpdateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>>;

    /**
     * Update template metadata (not the PDF itself)
     * Update a form template
     */
    updateFormTemplate(requestParameters: UpdateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate>;

}

/**
 * 
 */
export class FormTemplatesApi extends runtime.BaseAPI implements FormTemplatesApiInterface {

    /**
     * Mark a sent form as cancelled
     * Cancel a form document
     */
    async cancelFormDocumentRaw(requestParameters: CancelFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling cancelFormDocument().'
            );
        }

        if (requestParameters['formDocId'] == null) {
            throw new runtime.RequiredError(
                'formDocId',
                'Required parameter "formDocId" was null or undefined when calling cancelFormDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/forms/{formDocId}/cancel`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"formDocId"}}`, encodeURIComponent(String(requestParameters['formDocId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormDocumentFromJSON(jsonValue));
    }

    /**
     * Mark a sent form as cancelled
     * Cancel a form document
     */
    async cancelFormDocument(requestParameters: CancelFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument> {
        const response = await this.cancelFormDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a PDF form template
     * Create a new form template
     */
    async createFormTemplateRaw(requestParameters: CreateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>> {
        if (requestParameters['createFormTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createFormTemplateRequest',
                'Required parameter "createFormTemplateRequest" was null or undefined when calling createFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFormTemplateRequestToJSON(requestParameters['createFormTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormTemplateFromJSON(jsonValue));
    }

    /**
     * Upload a PDF form template
     * Create a new form template
     */
    async createFormTemplate(requestParameters: CreateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate> {
        const response = await this.createFormTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes a completed or cancelled form document while retaining its database record and stored completed PDF blob for audit purposes
     * Delete a form document
     */
    async deleteFormDocumentRaw(requestParameters: DeleteFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteFormDocument().'
            );
        }

        if (requestParameters['formDocId'] == null) {
            throw new runtime.RequiredError(
                'formDocId',
                'Required parameter "formDocId" was null or undefined when calling deleteFormDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/forms/{formDocId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"formDocId"}}`, encodeURIComponent(String(requestParameters['formDocId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft deletes a completed or cancelled form document while retaining its database record and stored completed PDF blob for audit purposes
     * Delete a form document
     */
    async deleteFormDocument(requestParameters: DeleteFormDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFormDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Soft deletes the template while retaining its database record and stored PDF blob for audit purposes
     * Delete a form template
     */
    async deleteFormTemplateRaw(requestParameters: DeleteFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft deletes the template while retaining its database record and stored PDF blob for audit purposes
     * Delete a form template
     */
    async deleteFormTemplate(requestParameters: DeleteFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFormTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve the completed PDF file for a submitted form document
     * Get completed form PDF
     */
    async getCompletedFormPdfRaw(requestParameters: GetCompletedFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getCompletedFormPdf().'
            );
        }

        if (requestParameters['formDocId'] == null) {
            throw new runtime.RequiredError(
                'formDocId',
                'Required parameter "formDocId" was null or undefined when calling getCompletedFormPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/forms/{formDocId}/pdf`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"formDocId"}}`, encodeURIComponent(String(requestParameters['formDocId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve the completed PDF file for a submitted form document
     * Get completed form PDF
     */
    async getCompletedFormPdf(requestParameters: GetCompletedFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCompletedFormPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve field placement configuration for a form template
     * Get field placements for a template
     */
    async getFieldPlacementsRaw(requestParameters: GetFieldPlacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFieldPlacementsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFieldPlacements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}/field-placements`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFieldPlacementsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve field placement configuration for a form template
     * Get field placements for a template
     */
    async getFieldPlacements(requestParameters: GetFieldPlacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFieldPlacementsResponse> {
        const response = await this.getFieldPlacementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve form details for homeowner submission
     * Get form by access token (public, no auth)
     */
    async getFormByTokenRaw(requestParameters: GetFormByTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFormByTokenResponse>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling getFormByToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/forms/{accessToken}`.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFormByTokenResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve form details for homeowner submission
     * Get form by access token (public, no auth)
     */
    async getFormByToken(requestParameters: GetFormByTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFormByTokenResponse> {
        const response = await this.getFormByTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all form documents sent for a specific claim
     * Get form documents for a claim
     */
    async getFormDocumentsByClaimRaw(requestParameters: GetFormDocumentsByClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFormDocumentsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getFormDocumentsByClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/forms`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListFormDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * List all form documents sent for a specific claim
     * Get form documents for a claim
     */
    async getFormDocumentsByClaim(requestParameters: GetFormDocumentsByClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFormDocumentsResponse> {
        const response = await this.getFormDocumentsByClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single form template
     * Get a form template by ID
     */
    async getFormTemplateByIdRaw(requestParameters: GetFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFormTemplateById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormTemplateFromJSON(jsonValue));
    }

    /**
     * Retrieve a single form template
     * Get a form template by ID
     */
    async getFormTemplateById(requestParameters: GetFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate> {
        const response = await this.getFormTemplateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the PDF file for a form template
     * Get form template PDF
     */
    async getFormTemplatePdfRaw(requestParameters: GetFormTemplatePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFormTemplatePdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}/pdf`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve the PDF file for a form template
     * Get form template PDF
     */
    async getFormTemplatePdf(requestParameters: GetFormTemplatePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getFormTemplatePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the original PDF template for a form document via access token
     * Get form template PDF (public, no auth)
     */
    async getPublicFormPdfRaw(requestParameters: GetPublicFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling getPublicFormPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/forms/{accessToken}/pdf`.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve the original PDF template for a form document via access token
     * Get form template PDF (public, no auth)
     */
    async getPublicFormPdf(requestParameters: GetPublicFormPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getPublicFormPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all form templates for the authenticated user\'s company
     * List all form templates
     */
    async listFormTemplatesRaw(requestParameters: ListFormTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFormTemplatesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListFormTemplatesResponseFromJSON(jsonValue));
    }

    /**
     * Get all form templates for the authenticated user\'s company
     * List all form templates
     */
    async listFormTemplates(requestParameters: ListFormTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFormTemplatesResponse> {
        const response = await this.listFormTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a form document instance and send it to the homeowner
     * Send a form to a homeowner
     */
    async sendFormToHomeownerRaw(requestParameters: SendFormToHomeownerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling sendFormToHomeowner().'
            );
        }

        if (requestParameters['sendFormDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'sendFormDocumentRequest',
                'Required parameter "sendFormDocumentRequest" was null or undefined when calling sendFormToHomeowner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/forms/send`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendFormDocumentRequestToJSON(requestParameters['sendFormDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormDocumentFromJSON(jsonValue));
    }

    /**
     * Create a form document instance and send it to the homeowner
     * Send a form to a homeowner
     */
    async sendFormToHomeowner(requestParameters: SendFormToHomeownerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument> {
        const response = await this.sendFormToHomeownerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Homeowner submits the filled form with annotations and signature
     * Submit a form (public, no auth)
     */
    async submitFormRaw(requestParameters: SubmitFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormDocument>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling submitForm().'
            );
        }

        if (requestParameters['submitFormDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'submitFormDocumentRequest',
                'Required parameter "submitFormDocumentRequest" was null or undefined when calling submitForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/forms/{accessToken}/submit`.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitFormDocumentRequestToJSON(requestParameters['submitFormDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormDocumentFromJSON(jsonValue));
    }

    /**
     * Homeowner submits the filled form with annotations and signature
     * Submit a form (public, no auth)
     */
    async submitForm(requestParameters: SubmitFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormDocument> {
        const response = await this.submitFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update field placement configuration for a form template
     * Update field placements for a template
     */
    async updateFieldPlacementsRaw(requestParameters: UpdateFieldPlacementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFieldPlacementsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFieldPlacements().'
            );
        }

        if (requestParameters['updateFieldPlacementsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFieldPlacementsRequest',
                'Required parameter "updateFieldPlacementsRequest" was null or undefined when calling updateFieldPlacements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}/field-placements`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFieldPlacementsRequestToJSON(requestParameters['updateFieldPlacementsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFieldPlacementsResponseFromJSON(jsonValue));
    }

    /**
     * Update field placement configuration for a form template
     * Update field placements for a template
     */
    async updateFieldPlacements(requestParameters: UpdateFieldPlacementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFieldPlacementsResponse> {
        const response = await this.updateFieldPlacementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update template metadata (not the PDF itself)
     * Update a form template
     */
    async updateFormTemplateRaw(requestParameters: UpdateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFormTemplate().'
            );
        }

        if (requestParameters['updateFormTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFormTemplateRequest',
                'Required parameter "updateFormTemplateRequest" was null or undefined when calling updateFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFormTemplateRequestToJSON(requestParameters['updateFormTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormTemplateFromJSON(jsonValue));
    }

    /**
     * Update template metadata (not the PDF itself)
     * Update a form template
     */
    async updateFormTemplate(requestParameters: UpdateFormTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormTemplate> {
        const response = await this.updateFormTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
